<div class="search-row">
  <div class="table-sort">
    <input class="borderless-input" matInput type="text" [placeholder]="searchDescription ?? 'Search by name/email/phone/unit/property'"
      [(ngModel)]="searchName" (keyup.enter)="onSearch()" />

    <span class="action-icon-container" (click)="onSearch()">
      <img class="action-icon" src="./assets/images/search-icon.svg" alt="">
    </span>
  </div>
</div>
